import React, { useState, useContext, useEffect, useRef, useCallback } from 'react'
import styled from 'styled-components'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { routeMap } from '../../route'
import { GlobalContext } from '../../context/global.context'
import { useSelector } from 'react-redux'
import useAuthApi from '../../apis/useAuthApi'
import { setUserAuthInfo } from '../../utils/localStorageService'
import KidsPinPopup from './KidsPinPopUp'
// ---Importing other Components---
// import Avatar from './Avatar'
// import { avatarImage1 } from './MultiProgileImages'
import IndivudualProfile from './IndivudualProfile'
import { useHistory } from 'react-router-dom'

// --Temperory Imports ---
// import appMessages from './appMessages.json'

// --- Imports to be modified ---
import EditPencilIcon from './EditPencilIcon'
import EditPencilIconFilled from './EditPencilIconFilled'
import CloseIcon from './CloseIcon'

import GoBackArrowIcon from './GoBackArrowIcon'
import { getLabelsObject } from './PinPopUpdata'
import MultiProfileConfirmPopUp from './MultiProfileConfirmPopUp'
import Spinner from '../Spinner'
/* --------------------------------------------- */
import useLogout from '../../containers/useLogout'
/* --------------------------------------------- */
import useErrorUtils from '../../utils/useErrorUtils'
/* --------------------------------------------- */
const ProfileListPopup = () => {
    const { dispatch, userInfo, selectedProfile, userToken, showProfileDetails } = useContext(GlobalContext)
    const { profileManagementThemes = {} } = useSelector(store => store.profileManagement)
    const { appMessages = {} } = useSelector(store => store.appConfigReducers)
    const { appConfig } = useSelector(store => store.appConfigReducers)
    const { selectProfileAPI, updateAccountAPI, getAccountDetails } = useAuthApi()
    const logout = useLogout()
    const { showError } = useErrorUtils()
    const history = useHistory()
    /* --------------------------------------------- */
    const [isEdit, setIsEdit] = useState(false)
    const [editIconHover, setEditIconHover] = useState(false)
    // const [userInfoLocal, setUserInfoLocal ] = useState({})
    const [baseUrl, updateBaseUrl] = useState(null)
    const [allowExitFromPopup, setAllowExitFromPopup] = useState(null)
    const [showKidsPinPopup, setShowKidsPinPopup] = useState(false)
    const [kidsPinPopupStatus, setKidsPinPopupStatus] = useState(false)
    const [resetPinInitiated, setResetPinInitiated] = useState(false)
    const [popUpTexts, setpopUpTexts] = useState(null)
    const [profiles, setProfiles] = useState([])
    const [isLoading, setLoading] = useState(true)
    /* --------------------------------------------- */
    const contentRef = useRef()
    const userInfoRef = useRef(userInfo)
    const userTokenRef = useRef(userToken)
    /* --------------------------------------------- */
    const logoutUser = useCallback(() => {
        logout()
        dispatch({ type: 'UNAUTHENTICATED' })
        dispatch({ type: 'USER_INFO', value: {} })
        dispatch({ type: 'USER_TOKEN', value: '' })
        dispatch({ type: 'GUEST_LOGIN_STATUS', value: 'INITIATE'})
        dispatch({ type: 'SELECTED_PROFILE', value: {} })
        dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })
        history.push(routeMap.login)
    }, [dispatch, logout, history])
    /* --------------------------------------------- */
    useEffect(() => {
        userInfoRef.current = userInfo
    }, [userInfo])
    /* --------------------------------------------- */
    useEffect(() => {
        userTokenRef.current = userToken
    }, [userToken])
    /* --------------------------------------------- */
    useEffect(() => {
        let contentEl = contentRef.current
        disableBodyScroll(contentEl)
        return () => {
            enableBodyScroll(contentEl)
        }
    }, [])
    /* --------------------------------------------- */
    useEffect(() => {
        let isMounted = true;
        if (!baseUrl) return

        const userInfo = userInfoRef.current || {}
        const userId = userInfo.userId || ''
        const token = userTokenRef.current || ''

        setLoading(true)

        getAccountDetails(baseUrl, { userId, token })
            .then((res) => {
                if(!isMounted) return
                res = res || {}
                const profiles = res.profiles || []
                setProfiles(profiles)
                setLoading(false)
            })
            .catch((error) => {
                if(!isMounted) return
                error = error || {}
                const errorCode = error.errorCode
                if (errorCode === 8008) logoutUser()
                setLoading(false)
            })

        return () => {
          isMounted = false
        }
    }, [baseUrl, getAccountDetails, logoutUser])
    /* --------------------------------------------- */
    useEffect(() => {
        if (userToken && userToken.length > 2) {
            setAllowExitFromPopup(true)
        }
    }, [userToken])
    /* --------------------------------------------- */
    const [theme, setTheme] = useState(null)

    // --Setting Profile List Theme---
    useEffect(() => {
        if (profileManagementThemes && profileManagementThemes.themeProfileList) setTheme(profileManagementThemes.themeProfileList)
    }, [profileManagementThemes])


    useEffect(() => {
        if (!appConfig.baseUrl) return
        updateBaseUrl(appConfig.baseUrl)
    }, [appConfig])

    if (!selectedProfile) {
        const selectedProfilefromLS = JSON.parse(localStorage.getItem('selected-profile'))
        if (selectedProfilefromLS) dispatch({ type: 'SELECTED_PROFILE', value: selectedProfilefromLS })

    }

    const [, setClickedProfile] = useState({})
    const [, setPopUpStatus] = useState(null)
    const [showForgotFunction, setShowForgotFunction] = useState(false)


    if (showProfileDetails) dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: false })


    const [tryingToSwitchToProfile, setTryingToSwitchToProfile] = useState({})


    const handleProfileSelect = (profile) => {
        if (profile && profile.profileId && selectedProfile && selectedProfile.profileId && profile.profileId === selectedProfile.profileId) {
            dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })
            return
        }
        setTryingToSwitchToProfile(profile)
        setClickedProfile(profile)
        if (selectedProfile && selectedProfile.type === 'Kid' && selectedProfile.requireExitPin === "true") {
            setpopUpTexts(getLabelsObject('verify-kids-pin-for-exit', appMessages))
            if (!showForgotFunction) setShowForgotFunction(true)
            setKidsPinPopupStatus('verify-kids-pin-for-exit')
            setShowKidsPinPopup(true)
        }

        else {
            setLoading(true)
            const body = { "authInfo": userInfo.authInfo } //authInfo is there inside userInfo
            const urlParams = {
                "profileId": profile.profileId,
                "userId": userInfo.userId
            }

            selectProfileAPI(baseUrl, body, urlParams).then((res = {}) => {
                dispatch({ type: 'USER_TOKEN', value: res.token })
                dispatch({ type: 'GUEST_LOGIN_STATUS', value: 'NOT_NEEDED'})
                setUserAuthInfo({ token: res.token }, { merge: true })
                let profileType = res.profile[0].type === 'Kid' ? 'kids' : 'normal'
                setUserAuthInfo({ profileType: profileType }, { merge: true })
                // setUserAuthInfo({ profileType: 'admin' }, { merge: true })
                dispatch({ type: 'SELECTED_PROFILE', value: res.profile[0] })
                window.store.localStorage.setItem('selected-profile', JSON.stringify(res.profile[0]))

                // setUserAuthInfo({ token: res.token }, { merge: true })

                const headersParams = {
                    userId: userInfo.userId,
                    token: res.token
                }
                getAccountDetails(baseUrl, headersParams).then((res) => {
                    let newUserInfo = { ...userInfo, ...res, token: headersParams.token, profileType: profileType }
                    dispatch({ type: 'USER_INFO', value: newUserInfo })
                    setUserAuthInfo(newUserInfo)
                    setLoading(false)

                    if (window.store.localStorage.getItem('RESET_PIN')) {
                        //trigger pin reset flow.
                        if (profile.type === 'Adult') {
                            setResetPinInitiated(true)
                            window.store.localStorage.removeItem('RESET_PIN')
                            setpopUpTexts(getLabelsObject('create-kids-pin', appMessages))
                            setShowKidsPinPopup(true)
                            setKidsPinPopupStatus('create-kids-pin')

                        } else {
                            window.store.localStorage.removeItem('RESET_PIN')
                        }
                    }
                    else dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })

                    history.push('/')
                    // if (profile.type === 'Adult') history.push('/')
                    // else if (profile.type === 'Kid') history.push('/catalog/kids_profile')

                })
                // window.location.reload(false); //false default, if true it will reload from server

            }).catch((e) => console.log('Error in selectProfileAPI', e))

        }
    }



    const handleCreateNewProfile = () => {
        if (profiles.length >= 5) {
            setpopUpTexts(getLabelsObject('maximum-profiles-reached', appMessages))
            setShowMessagePopUp(true)
            return
        }
        dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })
        dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: { "flag": true, "profile": null } })
    }

    const handleEditProfileClick = (clickedProject) => {
        dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })
        dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: { "flag": true, "profile": clickedProject } })
    }




    const [showMessagePopUp, setShowMessagePopUp] = useState(false)
    const [tempPINStrorage, setTempPINStrorage] = useState(0)
    const [pinEnterCount, setPinEnterCount] = useState(0)

    const handlePinPopupReturn = (returnedPIN) => {
        if (kidsPinPopupStatus === 'verify-kids-pin-for-exit') {
            if (returnedPIN === userInfo.profilePin) {
                setShowKidsPinPopup(false)
                setLoading(true)
                const body = { "authInfo": userInfo.authInfo } //authInfo is there inside userInfo
                const urlParams = {
                    "profileId": tryingToSwitchToProfile.profileId,
                    "userId": userInfo.userId
                }
                selectProfileAPI(baseUrl, body, urlParams).then((res = {}) => {
                    dispatch({ type: 'USER_TOKEN', value: res.token })
                    dispatch({ type: 'GUEST_LOGIN_STATUS', value: 'NOT_NEEDED'})
                    setUserAuthInfo({ token: res.token }, { merge: true })
                    let profileType = res.profile[0].type === 'Kid' ? 'kids' : 'normal'
                    setUserAuthInfo({ profileType: profileType }, { merge: true })
                    dispatch({ type: 'SELECTED_PROFILE', value: res.profile[0] })
                    window.store.localStorage.setItem('selected-profile', JSON.stringify(res.profile[0]))
                    const headersParams = {
                        userId: userInfo.userId,
                        token: res.token
                    }
                    getAccountDetails(baseUrl, headersParams).then((res) => {
                        let newUserInfo = { ...userInfo, ...res, token: headersParams.token, profileType: profileType }
                        dispatch({ type: 'USER_INFO', value: newUserInfo })
                        setUserAuthInfo(newUserInfo)
                        dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })
                        setLoading(false)
                    })
                    // window.location.reload(false); //false default, if true it will reload from server
                }).catch((e) => {
                    setLoading(false)

                })
            } else {
                if (pinEnterCount < 4) {
                    setPinEnterCount(pinEnterCount + 1)
                    showError({ type: 'incorrectPIN' })
                    setpopUpTexts(getLabelsObject('verify-kids-pin-for-exit', appMessages))
                    setKidsPinPopupStatus('verify-kids-pin-for-exit')
                    setShowKidsPinPopup(true)
                } else {

                    setpopUpTexts(getLabelsObject('do-you-want-pin-reset', appMessages))
                    setPopUpFunctions({
                        "positiveButtonFunction": () => {
                            setShowMessagePopUp(false)
                        },
                        "negativeButtonFunction": () => {
                            //save flag to local storage and initiate logout.
                            dispatch({ type: 'USER_INFO', value: {} })
                            dispatch({ type: 'UNAUTHENTICATED' })
                            history.push(routeMap.login)
                            window.store.localStorage.clear()
                            window.store.localStorage.setItem('RESET_PIN', selectedProfile.profileId)
                            dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: { "flag": false, "profile": null } })
                        }
                    })
                    setShowKidsPinPopup(false)
                    setShowMessagePopUp(true)
                    setPinEnterCount(0)
                }
            }
        }
        else if (kidsPinPopupStatus === 'change-pin-enter-existing-pin') {
            if (returnedPIN === userInfo.profilePin) {
                setpopUpTexts(getLabelsObject('change-pin-enter-new-pin', appMessages))
                setKidsPinPopupStatus('change-pin-enter-new-pin')
                setShowKidsPinPopup(true)
            } else {

                if (pinEnterCount < 4) {
                    setPinEnterCount(pinEnterCount + 1)
                    showError({ type: 'incorrectPIN' })
                    setpopUpTexts(getLabelsObject('change-pin-enter-existing-pin', appMessages))
                    setKidsPinPopupStatus('change-pin-enter-existing-pin')
                    setShowKidsPinPopup(true)
                } else {

                    setpopUpTexts(getLabelsObject('do-you-want-pin-reset', appMessages))
                    setPopUpFunctions({
                        "positiveButtonFunction": () => {
                            setShowMessagePopUp(false)
                        },
                        "negativeButtonFunction": () => {
                            //save flag to local storage and initiate logout.
                            dispatch({ type: 'USER_INFO', value: {} })
                            dispatch({ type: 'UNAUTHENTICATED' })
                            history.push(routeMap.login)
                            window.store.localStorage.clear()
                            window.store.localStorage.setItem('RESET_PIN', selectedProfile.profileId)
                            dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })
                            setShowMessagePopUp(false)

                        }
                    })
                    setShowKidsPinPopup(false)
                    setShowMessagePopUp(true)
                    setPinEnterCount(0)
                }
            }
        }
        else if (kidsPinPopupStatus === 'change-pin-enter-new-pin') {
            setTempPINStrorage(returnedPIN)
            setpopUpTexts(getLabelsObject('change-pin-enter-new-pin-confirm', appMessages))
            setKidsPinPopupStatus('change-pin-enter-new-pin-confirm')
            setShowKidsPinPopup(true)
        }
        else if (kidsPinPopupStatus === 'change-pin-enter-new-pin-confirm') {
            //Set PIN API
            if (tempPINStrorage === returnedPIN) {
                setLoading(true)

                const headersParams = {
                    userId: userInfo.userId,
                    token: userToken
                }
                updateAccountAPI(baseUrl, { profilePin: returnedPIN }, headersParams)
                    .then(() => {

                        const headersParams = {
                            userId: userInfo.userId,
                            token: userToken
                        }
                        getAccountDetails(baseUrl, headersParams).then((res) => {
                            let newUserInfo = { ...userInfo, ...res, token: headersParams.token }
                            dispatch({ type: 'USER_INFO', value: newUserInfo })
                            setUserAuthInfo(newUserInfo)
                            setpopUpTexts(getLabelsObject('pin-changed-message', appMessages))
                            setShowKidsPinPopup(false)
                            setLoading(false)
                            setShowMessagePopUp(true)
                        })
                    }).catch(() => {
                        showError({ type: 'errorUpdatingProfile' })
                        setLoading(false)
                    })

            }
            else {
                showError({ type: 'pinNotMatching' })
                setpopUpTexts(getLabelsObject('change-pin-enter-new-pin-confirm', appMessages))
                setKidsPinPopupStatus('change-pin-enter-new-pin-confirm')
                setShowKidsPinPopup(true)
            }

        } else if (kidsPinPopupStatus === 'create-kids-pin') {
            setTempPINStrorage(returnedPIN)
            setpopUpTexts(getLabelsObject('create-kids-pin-confirm', appMessages))
            setShowForgotFunction(null)
            setShowKidsPinPopup(true)
            setKidsPinPopupStatus('create-kids-pin-confirm')
        } else if (kidsPinPopupStatus === 'create-kids-pin-confirm') {
            if (tempPINStrorage === returnedPIN) {
                //Set PIN API
                setLoading(true)
                const headersParams = {
                    userId: userInfo.userId,
                    token: userToken
                }
                updateAccountAPI(baseUrl, { profilePin: tempPINStrorage }, headersParams)
                    .then(() => {
                        dispatch({ type: 'USER_INFO', value: { ...userInfo, profilePin: tempPINStrorage } })
                        setUserAuthInfo({ ...userInfo, profilePin: tempPINStrorage })
                        setShowKidsPinPopup(false)
                        setLoading(false)
                        if (!resetPinInitiated) setpopUpTexts(getLabelsObject('kids-pin-created-succesfully', appMessages))
                        else {
                            setpopUpTexts(getLabelsObject('pin-changed-message', appMessages))
                            setResetPinInitiated(false)
                        }
                        setPopUpFunctions({
                            "singleButtonFunction": () => setShowMessagePopUp(false)
                        })
                        setShowMessagePopUp(true)

                    }).catch(() => {
                        showError({ type: 'errorUpdatingProfile' })
                        setLoading(false)
                    })
            } else {
                showError({ type: 'pinNotMatching' })
                setpopUpTexts(getLabelsObject('create-kids-pin-confirm', appMessages))
                setShowKidsPinPopup(true)
                setPopUpStatus('create-kids-pin-confirm')
            }
        }
    }



    const handleUpdatePin = () => {
        setpopUpTexts(getLabelsObject('change-pin-enter-existing-pin', appMessages))
        setKidsPinPopupStatus('change-pin-enter-existing-pin')
        setShowForgotFunction(true)
        setShowKidsPinPopup(true)
    }

    const [popUpFunctions, setPopUpFunctions] = useState({ singleButtonFunction: () => setShowMessagePopUp(false) })

    const handleForgotPinFunction = () => {
        //show want to reset
        setpopUpTexts(getLabelsObject('forgot-pin-login-confirmation', appMessages))
        setPopUpFunctions({
            "positiveButtonFunction": () => {
                setShowMessagePopUp(false)
            },
            "negativeButtonFunction": () => {
                //save flag to local storage and initiate logout.
                dispatch({ type: 'USER_INFO', value: {} })
                dispatch({ type: 'UNAUTHENTICATED' })
                history.push(routeMap.login)
                window.store.localStorage.clear()
                window.store.localStorage.setItem('RESET_PIN', 'This Flag exist because the user triggered a reset password on next login')
                dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: { "flag": false, "profile": null } })
                setShowMessagePopUp(false)
                dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })



            }
        })
        setShowKidsPinPopup(false)
        setShowMessagePopUp(true)
    }

    //Taking all kids profile into an array for logic to show or hide 'UPDATE KIDS PIN'
    const [kidProfileArray, setKidProfileArray] = useState([])

    useEffect(() => {
        if (profiles) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            setKidProfileArray(profiles.filter(profile => profile.type === 'Kid')
            )
        }
    }, [profiles])


    return (
        <ProfileListPopupStyled theme={theme}>
            <div className="multi-profile-list-popup pop-up-container">
                <div className="pop-up-container___content-wrapper">
                    <div className="multi-profile-list-popup__header">
                        {isEdit && <div className="multi-profile-list-popup__header__back-icon" onClick={() => setIsEdit(false)}><GoBackArrowIcon color='#ffd200' height='20px' /></div>}
                        <div className="multi-profile-list-popup__header__title">{isEdit ? appMessages.label_profile_popup_title_edit_profile : appMessages.label_profile_popup_title}</div>
                        {!isEdit && (!selectedProfile || selectedProfile.type !== 'Kid') && <div className="multi-profile-list-popup__header__edit-icon" onMouseEnter={() => setEditIconHover(true)} onMouseLeave={() => setEditIconHover(false)} onClick={() => setIsEdit(true)}>
                            {editIconHover ? <EditPencilIconFilled color={theme && theme.header && theme.header.accent && theme.header.accent.primary} height='21px' /> : <EditPencilIcon color={theme && theme.header && theme.header.accent && theme.header.accent.primary} height='21px' />}
                        </div>}
                        {allowExitFromPopup && <div className="multi-profile-list-popup__header__clode-icon" onClick={() => dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: false })}><CloseIcon color={theme && theme.header && theme.header.accent && theme.header.accent.primary} height='20px' /></div>}
                    </div>
                    <div className="multi-profile-list-popup__body" ref={contentRef}>
                        <div className="multi-profile-list-popup__body__profile-list">
                            {profiles.map((profile) => {
                                return <div className="indivudual-profile-single" key={profile.profileId} onClick={() => isEdit ? null : handleProfileSelect(profile)}>
                                    <IndivudualProfile editFunction={() => handleEditProfileClick(profile)} isKid={profile.type === 'Adult' ? false : true} avatar={profile.avatar} name={profile.name} isThisProfileSelected={selectedProfile && profile && selectedProfile.profileId && profile.profileId && selectedProfile.profileId === profile.profileId} isEditEnabled={isEdit} isThisKids={selectedProfile && selectedProfile.type && selectedProfile.type === 'Kid'} />
                                </div>
                            })}
                            {!isLoading && (!selectedProfile || selectedProfile.type !== 'Kid') && !isEdit && <div className="multi-profile-list-popup__body__profile-list__buttons">
                                <div onClick={() => handleCreateNewProfile()} className="multi-profile-list-popup__body__profile-list__buttons__create-new">{appMessages.label_profile_new_profile}</div>
                                {userInfo && userInfo.profilePin && userInfo.profilePin !== 'null' && kidProfileArray.length !== 0 && <div className="multi-profile-list-popup__body__profile-list__buttons__update-pin" onClick={() => handleUpdatePin()}>{appMessages.label_profile_update_pin}</div>}
                            </div>}
                            <Spinner IsLoading={isLoading} size={60} />
                        </div>
                    </div>
                </div>
            </div>
            {showKidsPinPopup && <KidsPinPopup labels={popUpTexts} successFunction={handlePinPopupReturn} cancelFunction={() => setShowKidsPinPopup(false)} forgotFunction={showForgotFunction ? () => handleForgotPinFunction() : null} />}
            {showMessagePopUp && <MultiProfileConfirmPopUp text={popUpTexts} functions={popUpFunctions} />}
        </ProfileListPopupStyled>
    )
};

const ProfileListPopupStyled = styled.div`

.pop-up-container___content-wrapper {
    z-index: 5;
    background-color:  ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.selectorStyle && compositeStyle.selectorStyle.normal && compositeStyle.selectorStyle.normal.background};
}
.multi-profile-list-popup__body__profile-list__buttons{
    .multi-profile-list-popup__body__profile-list__buttons__create-new{
        background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.normal.background};
        color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.normal.text};

        :hover{
            background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.focussed.background};
            color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal && compositeStyle.primaryButton.focussed.text};
        }
    }
}

.multi-profile-list-popup{
    .multi-profile-list-popup__header{

        .multi-profile-list-popup__header__back-icon{
            margin-right: 17px;
            color: ${({ theme: { header } }) => header && header.accent && header.accent.primary};
        }//multi-profile-list-popup__header__back-icon

        .multi-profile-list-popup__header__title{
            color: ${({ theme: { header } }) => header && header.accent && header.accent.primary};
        }//multi-profile-list-popup__header__title

        .multi-profile-list-popup__header__edit-icon{
            margin-left: 15px;
        }//multi-profile-list-popup__header__edit-icon

        .multi-profile-list-popup__header__clode-icon{
            margin-left: auto;
        }//multi-profile-list-popup__header__clode-icon


    }//multi-profile-list-popup__header

    .multi-profile-list-popup__body{

        .multi-profile-list-popup__body__profile-list{
        }//multi-profile-list-popup__body__profile-list
    }//multi-profile-list-popup__body



}//multi-profile-list-popup
`

export default ProfileListPopup
